import QuillEditor from 'react-quill'

import 'react-quill/dist/quill.snow.css'
import { editorStyles } from './styles'

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'bullet' }],
    ['link'],
    ['clean']
  ]
}

type Props = {
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  height?: number
}

export const RichTextEditor = ({
  value,
  onChange,
  placeholder,
  height
}: Props) => {
  const { styles } = editorStyles({ height })

  return (
    <QuillEditor
      modules={modules}
      className={styles.editor}
      theme="snow"
      value={value}
      onChange={(value) => onChange?.(value)}
      placeholder={placeholder}
    />
  )
}
